import { useResourceFormContext } from "src/components/Form/hooks/useResourceFormContext.ts";
import { useOne } from "src/system/useOne.tsx";
import { useCreateForm } from "src/system/useCreateForm.tsx";
import { FORM_QUERY_OPTIONS } from "src/components/Form/Form.constants.ts";
import { FormAction } from "src/components/Form/Form.types.ts";

export const useResourceFormQuery = () => {
  const {
    action,
    resource,
    lang,
    id,
    formConfig: { includes, pretendLoadingNewForm, meta: metaFromConfig },
    meta,
    requestParams,
  } = useResourceFormContext();

  const createQueryResult = useCreateForm({
    resource,
    locale: lang,
    meta,
    requestParams,
    pretend: pretendLoadingNewForm,
    queryOptions: {
      enabled: action === FormAction.Create,
      ...FORM_QUERY_OPTIONS,
    },
  });

  const editQueryResult = useOne({
    lang: lang,
    id: id!,
    includes: includes,
    resource,
    requestParams,
    meta: {
      ...meta,
      ...metaFromConfig,
    },
    queryOptions: {
      enabled: action === FormAction.Edit,
      ...FORM_QUERY_OPTIONS,
    },
  });

  return action === "edit" ? editQueryResult : createQueryResult;
};
